import { Box, Button, Typography, useTheme } from '@mui/material';
import { IllustrationXLargeMulti } from '@care/react-embrace-icons';
import getConfig from 'next/config';
import useResponsive from '@/components/hooks/useResponsive';
import { PLANS_PRICING_URL, VERTICALS_NAMES } from '@/constants';
import { AnalyticsHelper } from '@/utilities/AnalyticsHelper';
import { AnalyticsEventName, CtaLocation, CtaText, ScreenName } from '@/types/enums';

const {
  publicRuntimeConfig: { CZEN_GENERAL },
} = getConfig();

const Plans = () => {
  const theme = useTheme();
  const { isMobile, isTablet } = useResponsive();

  const handlePlansAndPricingClick = () => {
    AnalyticsHelper.logEvent({
      name: AnalyticsEventName.CTA_INTERACTED_VHP,
      data: {
        cta_location: CtaLocation.VHP_BODY,
        cta_text: CtaText.PLANS_AND_PRICING,
        enrollment_initiated: false,
        screen_name: ScreenName.VISITOR_HOMEPAGE,
        vertical: VERTICALS_NAMES.unknown,
      },
    });

    window.location.assign(`${CZEN_GENERAL}${PLANS_PRICING_URL}`);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        justifyItems: 'center',
        flexDirection: { xs: 'column', sm: 'row' },
        padding: {
          xs: theme.spacing(6, 3, '107px', 3),
          sm: theme.spacing('38px', 4, '70px', 4),
          md: theme.spacing('103px', 4, '95px'),
        },
        overflow: 'hidden',
        position: 'relative',
      }}>
      <Box
        sx={{
          backgroundColor: theme.palette.background.secondary,
          borderRadius: '32px',
          alignSelf: 'center',
          padding: { xs: 3, sm: theme.spacing('36px', 6, 6) },
          width: { xs: '100%', sm: '770px', md: '1082px' },
          height: { xs: '850px', sm: '335px', md: '381px' },
        }}>
        <Box>
          <Typography
            variant={isMobile ? 'display3' : 'display2'}
            sx={{
              margin: 0,
              width: { xs: '100%', sm: '360px', md: '496px' },
            }}>
            Care for the whole household, under one plan.
          </Typography>
          <Button
            onClick={handlePlansAndPricingClick}
            sx={{ width: { xs: '100%', sm: '224px' }, mt: 4, zIndex: 10 }}
            color="primary"
            variant="outlined"
            size="large">
            Plans and pricing
          </Button>
        </Box>
        <Box
          data-testid="plans-illustration"
          sx={{
            position: 'absolute',
            transform: {
              xs: 'translateX(-135px) translateY(-75px)',
              sm: 'translateX(306px) translateY(-434px)',
              md: 'translateX(410px) translateY(-482px)',
            },
          }}>
          <IllustrationXLargeMulti width={isTablet ? '600px' : '709px'} />
        </Box>
      </Box>
    </Box>
  );
};

export default Plans;
